/* eslint-disable prefer-destructuring */

import Gatekeeper, {SESSION} from '@voicebase/gatekeeper';
import axios from 'axios';
import _ from 'lodash';

import * as C from './userConstants';

const AUTH0_CLIENT_ID = process.env.AUTH0_CLIENT_ID;
const AUTH0_DOMAIN = process.env.AUTH0_DOMAIN;
const SITE_DOMAIN = process.env.SITE_DOMAIN;
const AUTH0_CONNECTION = process.env.AUTH0_CONNECTION;
const API_URL = process.env.API_URL;
const NODE_ENV = process.env.NODE_ENV;
const GATEKEEPER_CONFIG = {
  clientID: AUTH0_CLIENT_ID,
  domain: AUTH0_DOMAIN,
  connection: AUTH0_CONNECTION,
  redirectUri: `${SITE_DOMAIN}/callback`,
};

// note- putting config in the bottle causes code to break! thats messed up.

export default (bottle) => {

  bottle.factory('gatekeeper', ({}) => new Gatekeeper(GATEKEEPER_CONFIG));

  bottle.factory('getEphemeralToken', () => (IDToken) => {
    if (!IDToken) {
      return null;
    }
    if (!(typeof IDToken === 'string')) {
      console.log('non string IDToken presented', IDToken);
      return null;
    }
    return axios.post(`${API_URL}/profile/keys`, {ttlMillis: 7200000, ephemeral: true}, {
      headers: {
        Authorization: `Bearer ${IDToken}`,
        'content-type': 'application/json',
      },
    })
      .then(result => _.get(result, 'data'));
  });
};
